var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "preview-panel" }, [
    _c("h4", [_vm._v("Template preview")]),
    _vm._v(" "),
    _vm.isCallPermissionPreview
      ? _c("div", { staticClass: "call-permission-preview" }, [
          _c("img", {
            attrs: {
              src: "https://static.supsis.live/common/image/call_permission_request_template.gif",
              alt: "Call Permission Request",
            },
          }),
        ])
      : _c(
          "div",
          { staticClass: "phone-preview" },
          [
            _c(
              "div",
              { staticClass: "message-bubble" },
              [
                _vm.currentStep === 0
                  ? [
                      _vm.form.category === "MARKETING" &&
                      _vm.form.templateType === "DEFAULT"
                        ? [
                            _vm.media &&
                            ["IMAGE", "VIDEO", "DOCUMENT"].includes(
                              _vm.form.headerFormat
                            )
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _vm.form.headerFormat === "IMAGE"
                                    ? _c("img", {
                                        staticClass: "preview-image",
                                        attrs: {
                                          src: _vm.media.data,
                                          alt: "Preview",
                                        },
                                      })
                                    : _vm.form.headerFormat === "VIDEO"
                                    ? _c("video", {
                                        staticClass: "preview-image",
                                        attrs: {
                                          src: _vm.media.data,
                                          controls: "",
                                        },
                                      })
                                    : _vm.form.headerFormat === "DOCUMENT"
                                    ? _c(
                                        "div",
                                        { staticClass: "document-preview" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("description")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.media.name)),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : ["IMAGE", "VIDEO", "DOCUMENT"].includes(
                                  _vm.form.headerFormat
                                )
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _c("img", {
                                    staticClass: "preview-image",
                                    attrs: {
                                      src: "https://static.supsis.live/common/image/fruits.png",
                                      alt: "Preview",
                                    },
                                  }),
                                ])
                              : _vm.form.headerFormat === "TEXT" &&
                                _vm.form.headerText
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-text-preview" },
                                    [_vm._v(_vm._s(_vm.form.headerText))]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.form.body ||
                                      "Hey there! Check out our fresh groceries now! Use code HEALTH to get additional 10% off on your entire purchase."
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.form.footer
                              ? _c("div", { staticClass: "footer-preview" }, [
                                  _vm._v(_vm._s(_vm.form.footer)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.category === "MARKETING" &&
                          _vm.form.templateType === "CAROUSEL"
                        ? [
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                "\n                        Check out our featured products! Swipe to explore amazing deals.\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.category === "MARKETING" &&
                          _vm.form.templateType === "LIMITED_TIME_OFFER"
                        ? [
                            _vm.media &&
                            ["IMAGE", "VIDEO"].includes(_vm.form.headerFormat)
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _vm.form.headerFormat === "IMAGE"
                                    ? _c("img", {
                                        staticClass: "preview-image",
                                        attrs: {
                                          src: _vm.media.data,
                                          alt: "Preview",
                                        },
                                      })
                                    : _vm.form.headerFormat === "VIDEO"
                                    ? _c("video", {
                                        staticClass: "preview-image",
                                        attrs: {
                                          src: _vm.media.data,
                                          controls: "",
                                        },
                                      })
                                    : _vm._e(),
                                ])
                              : ["IMAGE", "VIDEO"].includes(
                                  _vm.form.headerFormat
                                )
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _c("img", {
                                    staticClass: "preview-image",
                                    attrs: {
                                      src: "https://static.supsis.live/common/image/fruits.png",
                                      alt: "Preview",
                                    },
                                  }),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "limited-time-offer-preview" },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _c("div", { staticClass: "lto-content" }, [
                                  _c("div", { staticClass: "lto-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.form.limitedTimeOffer.text ||
                                          "Special Offer"
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "lto-expiry" }, [
                                    _vm._v("Ends in 2 days"),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.form.body ||
                                      "Starting now! Buy two, get one free on our new soap collection. Make this Black Friday unforgettable with artisanal, handmade soaps."
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.category === "MARKETING" &&
                          _vm.form.templateType === "COUPON_CODE"
                        ? [
                            _vm.form.headerFormat === "TEXT" &&
                            _vm.form.headerText
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-text-preview" },
                                    [_vm._v(_vm._s(_vm.form.headerText))]
                                  ),
                                ])
                              : _vm.form.headerFormat === "TEXT"
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-text-preview" },
                                    [_vm._v("Our Winter Sale is on!")]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.form.body ||
                                      "Shop now through the end of December and use the one-time use code WINTER25 to get 25% off of your entire order!"
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.category === "MARKETING" &&
                          _vm.form.templateType === "CATALOGUE"
                        ? [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "body-preview" },
                              [
                                _vm.form.catalogueSubType === "CATALOGUE"
                                  ? [
                                      _vm._v(
                                        "\n                            Now shop for your favorite products right here on WhatsApp! Browse our full catalogue.\n                        "
                                      ),
                                    ]
                                  : _vm.form.catalogueSubType ===
                                    "SINGLE_PRODUCT"
                                  ? [
                                      _vm._v(
                                        "\n                            Check out this amazing product! Perfect for your needs.\n                        "
                                      ),
                                    ]
                                  : _vm.form.catalogueSubType ===
                                    "MULTI_PRODUCT"
                                  ? [
                                      _vm._v(
                                        "\n                            Forget something? Looks like you left these items in your cart.\n                        "
                                      ),
                                    ]
                                  : _vm.form.catalogueSubType ===
                                    "PRODUCT_CARD_CAROUSEL"
                                  ? [
                                      _vm._v(
                                        "\n                            Discover our latest products! Browse our catalogue and find exactly what you're looking for.\n                        "
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.category === "UTILITY" &&
                          _vm.form.templateType === "DEFAULT"
                        ? [
                            _vm.media &&
                            ["IMAGE", "VIDEO", "DOCUMENT"].includes(
                              _vm.form.headerFormat
                            )
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _vm.form.headerFormat === "IMAGE"
                                    ? _c("img", {
                                        staticClass: "preview-image",
                                        attrs: {
                                          src: _vm.media.data,
                                          alt: "Preview",
                                        },
                                      })
                                    : _vm.form.headerFormat === "VIDEO"
                                    ? _c("video", {
                                        staticClass: "preview-image",
                                        attrs: {
                                          src: _vm.media.data,
                                          controls: "",
                                        },
                                      })
                                    : _vm.form.headerFormat === "DOCUMENT"
                                    ? _c(
                                        "div",
                                        { staticClass: "document-preview" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("description")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.media.name)),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm.form.headerFormat === "TEXT" &&
                                _vm.form.headerText
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-text-preview" },
                                    [_vm._v(_vm._s(_vm.form.headerText))]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.form.body ||
                                      "Good news! Your order 23KFEJJ2312 has shipped! Here's your tracking information, please check link below."
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.form.footer
                              ? _c("div", { staticClass: "footer-preview" }, [
                                  _vm._v(_vm._s(_vm.form.footer)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.category === "AUTHENTICATION"
                        ? [
                            _vm.media &&
                            ["IMAGE", "VIDEO", "DOCUMENT"].includes(
                              _vm.form.headerFormat
                            )
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _vm.form.headerFormat === "IMAGE"
                                    ? _c("img", {
                                        staticClass: "preview-image",
                                        attrs: {
                                          src: _vm.media.data,
                                          alt: "Preview",
                                        },
                                      })
                                    : _vm.form.headerFormat === "VIDEO"
                                    ? _c("video", {
                                        staticClass: "preview-image",
                                        attrs: {
                                          src: _vm.media.data,
                                          controls: "",
                                        },
                                      })
                                    : _vm.form.headerFormat === "DOCUMENT"
                                    ? _c(
                                        "div",
                                        { staticClass: "document-preview" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("description")]
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.media.name)),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm.form.headerFormat === "TEXT" &&
                                _vm.form.headerText
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-text-preview" },
                                    [_vm._v(_vm._s(_vm.form.headerText))]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.form.body ||
                                      "123456 is your verification code. For your security, do not share this code."
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm._e(),
                    ]
                  : [
                      _vm.form.templateType === "CAROUSEL"
                        ? [
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.body ||
                                    "Your carousel message body will appear here"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.templateType === "LIMITED_TIME_OFFER"
                        ? [
                            _vm.media
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _vm.form.headerFormat === "IMAGE"
                                    ? _c("img", {
                                        staticClass: "preview-image",
                                        attrs: {
                                          src: _vm.media.data,
                                          alt: "Preview",
                                        },
                                      })
                                    : _vm.form.headerFormat === "VIDEO"
                                    ? _c("video", {
                                        staticClass: "preview-image",
                                        attrs: { src: _vm.media.data },
                                      })
                                    : _vm._e(),
                                ])
                              : _vm.form.headerFormat === "IMAGE" ||
                                _vm.form.headerFormat === "VIDEO"
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "media-placeholder",
                                      class:
                                        _vm.form.headerFormat.toLowerCase(),
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.form.headerFormat === "IMAGE"
                                                ? "image"
                                                : "play_circle_filled"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.form.limitedTimeOffer &&
                            _vm.form.limitedTimeOffer.text
                              ? _c(
                                  "div",
                                  { staticClass: "limited-time-offer-preview" },
                                  [
                                    _vm._m(2),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "lto-content" }, [
                                      _c("div", { staticClass: "lto-title" }, [
                                        _vm._v(
                                          _vm._s(_vm.form.limitedTimeOffer.text)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.form.limitedTimeOffer.hasExpiration
                                        ? _c(
                                            "div",
                                            { staticClass: "lto-expiry" },
                                            [
                                              _vm._v(
                                                "\n                                Ends in 2 days\n                            "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.body ||
                                    "Your message body will appear here"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.templateType === "COUPON_CODE"
                        ? [
                            _vm.form.headerFormat === "TEXT" &&
                            _vm.form.headerText
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-text-preview" },
                                    [_vm._v(_vm._s(_vm.form.headerText))]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.body ||
                                    "Your message body will appear here"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.templateType === "CATALOGUE"
                        ? [
                            _vm._m(3),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.body ||
                                    "Your message body will appear here"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.form.footer
                              ? _c("div", { staticClass: "footer-preview" }, [
                                  _vm._v(_vm._s(_vm.form.footer)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.templateType === "CALL_PERMISSION"
                        ? [
                            _vm.form.headerFormat === "TEXT" &&
                            _vm.form.headerText
                              ? _c("div", { staticClass: "header-preview" }, [
                                  _c(
                                    "div",
                                    { staticClass: "header-text-preview" },
                                    [_vm._v(_vm._s(_vm.form.headerText))]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.body ||
                                    "Your message body will appear here"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.form.footer
                              ? _c("div", { staticClass: "footer-preview" }, [
                                  _vm._v(_vm._s(_vm.form.footer)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.category === "UTILITY"
                        ? [
                            _vm.form.headerFormat !== "NONE"
                              ? _c(
                                  "div",
                                  { staticClass: "header-preview" },
                                  [
                                    _vm.media
                                      ? [
                                          _vm.form.headerFormat === "IMAGE"
                                            ? _c("img", {
                                                staticClass: "preview-image",
                                                attrs: {
                                                  src: _vm.media.data,
                                                  alt: "Preview",
                                                },
                                              })
                                            : _vm.form.headerFormat === "VIDEO"
                                            ? _c("video", {
                                                staticClass: "preview-image",
                                                attrs: {
                                                  src: _vm.media.data,
                                                  controls: "",
                                                },
                                              })
                                            : _vm.form.headerFormat ===
                                              "DOCUMENT"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "document-preview",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("description")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(_vm.media.name)
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : ["IMAGE", "VIDEO", "DOCUMENT"].includes(
                                          _vm.form.headerFormat
                                        )
                                      ? [
                                          _vm.form.headerFormat === "IMAGE"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "media-placeholder image",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("image")]
                                                  ),
                                                ]
                                              )
                                            : _vm.form.headerFormat === "VIDEO"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "media-placeholder video",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "play_circle_filled"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm.form.headerFormat ===
                                              "DOCUMENT"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "media-placeholder document",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("description")]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.headerFormat === "TEXT" &&
                                    _vm.form.headerText
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "header-text-preview",
                                          },
                                          [_vm._v(_vm._s(_vm.form.headerText))]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.body ||
                                    "Your message body will appear here"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.form.footer
                              ? _c("div", { staticClass: "footer-preview" }, [
                                  _vm._v(_vm._s(_vm.form.footer)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : _vm.form.category === "AUTHENTICATION"
                        ? [
                            _vm.form.headerFormat !== "NONE"
                              ? _c(
                                  "div",
                                  { staticClass: "header-preview" },
                                  [
                                    _vm.media
                                      ? [
                                          _vm.form.headerFormat === "IMAGE"
                                            ? _c("img", {
                                                staticClass: "preview-image",
                                                attrs: {
                                                  src: _vm.media.data,
                                                  alt: "Preview",
                                                },
                                              })
                                            : _vm.form.headerFormat === "VIDEO"
                                            ? _c("video", {
                                                staticClass: "preview-image",
                                                attrs: {
                                                  src: _vm.media.data,
                                                  controls: "",
                                                },
                                              })
                                            : _vm.form.headerFormat ===
                                              "DOCUMENT"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "document-preview",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("description")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(_vm.media.name)
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : ["IMAGE", "VIDEO", "DOCUMENT"].includes(
                                          _vm.form.headerFormat
                                        )
                                      ? [
                                          _vm.form.headerFormat === "IMAGE"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "media-placeholder image",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("image")]
                                                  ),
                                                ]
                                              )
                                            : _vm.form.headerFormat === "VIDEO"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "media-placeholder video",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "play_circle_filled"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm.form.headerFormat ===
                                              "DOCUMENT"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "media-placeholder document",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("description")]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.headerFormat === "TEXT" &&
                                    _vm.form.headerText
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "header-text-preview",
                                          },
                                          [_vm._v(_vm._s(_vm.form.headerText))]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.body ||
                                    "Your message body will appear here"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.form.footer
                              ? _c("div", { staticClass: "footer-preview" }, [
                                  _vm._v(_vm._s(_vm.form.footer)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ]
                        : [
                            _vm.form.headerFormat !== "NONE"
                              ? _c(
                                  "div",
                                  { staticClass: "header-preview" },
                                  [
                                    _vm.media
                                      ? [
                                          _vm.form.headerFormat === "IMAGE"
                                            ? _c("img", {
                                                staticClass: "preview-image",
                                                attrs: {
                                                  src: _vm.media.data,
                                                  alt: "Preview",
                                                },
                                              })
                                            : _vm.form.headerFormat === "VIDEO"
                                            ? _c("video", {
                                                staticClass: "preview-image",
                                                attrs: {
                                                  src: _vm.media.data,
                                                  controls: "",
                                                },
                                              })
                                            : _vm.form.headerFormat ===
                                              "DOCUMENT"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "document-preview",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("description")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(_vm.media.name)
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : [
                                          _vm.form.headerFormat === "IMAGE"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "media-placeholder image",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("image")]
                                                  ),
                                                ]
                                              )
                                            : _vm.form.headerFormat === "VIDEO"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "media-placeholder video",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "play_circle_filled"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm.form.headerFormat ===
                                              "DOCUMENT"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "media-placeholder document",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("description")]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                    _vm._v(" "),
                                    _vm.form.headerFormat === "TEXT" &&
                                    _vm.form.headerText
                                      ? _c(
                                          "div",
                                          { staticClass: "header-text" },
                                          [_vm._v(_vm._s(_vm.form.headerText))]
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "body-preview" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.form.body ||
                                    "Your message body will appear here"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.form.footer
                              ? _c("div", { staticClass: "footer-preview" }, [
                                  _vm._v(_vm._s(_vm.form.footer)),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "time-stamp" }, [
                              _vm._v(_vm._s(_vm.getCurrentTime)),
                            ]),
                          ],
                    ],
              ],
              2
            ),
            _vm._v(" "),
            _vm.currentStep === 0 &&
            _vm.form.category === "MARKETING" &&
            (_vm.form.templateType === "DEFAULT" ||
              _vm.form.templateType === "CAROUSEL" ||
              _vm.form.templateType === "LIMITED_TIME_OFFER" ||
              _vm.form.templateType === "COUPON_CODE")
              ? _c(
                  "div",
                  { staticClass: "buttons-preview" },
                  [
                    _vm.form.templateType === "CAROUSEL"
                      ? [
                          _c(
                            "div",
                            { staticClass: "preview-button" },
                            [
                              _c("a-icon", { attrs: { type: "link" } }),
                              _vm._v(" View Product"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "preview-button" },
                            [
                              _c("a-icon", { attrs: { type: "phone" } }),
                              _vm._v(" Call Us"),
                            ],
                            1
                          ),
                        ]
                      : _vm.form.templateType === "LIMITED_TIME_OFFER"
                      ? [
                          _c(
                            "div",
                            { staticClass: "preview-button" },
                            [
                              _c("a-icon", { attrs: { type: "copy" } }),
                              _vm._v(" Copy offer code"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "preview-button" },
                            [
                              _c("a-icon", { attrs: { type: "link" } }),
                              _vm._v(" Shop now"),
                            ],
                            1
                          ),
                        ]
                      : _vm.form.templateType === "COUPON_CODE"
                      ? [
                          _c(
                            "div",
                            { staticClass: "preview-button" },
                            [
                              _c("a-icon", { attrs: { type: "message" } }),
                              _vm._v(" Unsubscribe"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "preview-button-copy-code" },
                            [
                              _c("a-icon", { attrs: { type: "copy" } }),
                              _vm._v(" Copy code"),
                            ],
                            1
                          ),
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "preview-button" },
                            [
                              _c("a-icon", { attrs: { type: "link" } }),
                              _vm._v(" Shop now"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "preview-button" },
                            [
                              _c("a-icon", { attrs: { type: "copy" } }),
                              _vm._v(" Copy code"),
                            ],
                            1
                          ),
                        ],
                  ],
                  2
                )
              : _vm.currentStep === 0 &&
                _vm.form.category === "MARKETING" &&
                _vm.form.templateType === "CATALOGUE"
              ? _c(
                  "div",
                  { staticClass: "buttons-preview" },
                  [
                    _vm.form.catalogueSubType === "CATALOGUE"
                      ? [
                          _c(
                            "div",
                            { staticClass: "preview-button" },
                            [
                              _c("a-icon", { attrs: { type: "shopping" } }),
                              _vm._v(" View catalog"),
                            ],
                            1
                          ),
                        ]
                      : _vm.form.catalogueSubType === "SINGLE_PRODUCT"
                      ? [
                          _c(
                            "div",
                            { staticClass: "preview-button" },
                            [
                              _c("a-icon", { attrs: { type: "shopping" } }),
                              _vm._v(" View"),
                            ],
                            1
                          ),
                        ]
                      : _vm.form.catalogueSubType === "MULTI_PRODUCT"
                      ? [
                          _c(
                            "div",
                            { staticClass: "preview-button" },
                            [
                              _c("a-icon", {
                                attrs: { type: "shopping-cart" },
                              }),
                              _vm._v(" View items"),
                            ],
                            1
                          ),
                        ]
                      : _vm.form.catalogueSubType === "PRODUCT_CARD_CAROUSEL"
                      ? [
                          _c(
                            "div",
                            { staticClass: "preview-button" },
                            [
                              _c("a-icon", { attrs: { type: "shopping" } }),
                              _vm._v(" View"),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm.currentStep === 0 &&
                _vm.form.category === "UTILITY" &&
                _vm.form.templateType === "DEFAULT"
              ? _c("div", { staticClass: "buttons-preview" }, [
                  _c(
                    "div",
                    { staticClass: "preview-button" },
                    [
                      _c("a-icon", { attrs: { type: "link" } }),
                      _vm._v(" Track shipment"),
                    ],
                    1
                  ),
                ])
              : _vm.currentStep === 0 &&
                _vm.form.templateType === "CALL_PERMISSION"
              ? _c("div", { staticClass: "buttons-preview" }, [
                  _c(
                    "div",
                    { staticClass: "preview-button-call-permission" },
                    [
                      _vm._v("\n                Choose preference "),
                      _c("a-icon", { attrs: { type: "down" } }),
                    ],
                    1
                  ),
                ])
              : _vm.currentStep === 0 && _vm.form.category === "AUTHENTICATION"
              ? _c("div", { staticClass: "buttons-preview" }, [
                  _c(
                    "div",
                    { staticClass: "preview-button" },
                    [
                      _c("a-icon", {
                        attrs: {
                          type:
                            _vm.form.authentication.otpSubType === "COPY_CODE"
                              ? "copy"
                              : "mobile",
                        },
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.form.authentication.otpSubType === "COPY_CODE"
                              ? "Copy code"
                              : _vm.form.authentication.otpSubType === "ONE_TAP"
                              ? "Autofill"
                              : "Auto-verify"
                          ) +
                          "\n            "
                      ),
                    ],
                    1
                  ),
                ])
              : _vm.currentStep > 0 &&
                _vm.form.templateType === "CALL_PERMISSION"
              ? _c("div", { staticClass: "buttons-preview" }, [
                  _c(
                    "div",
                    { staticClass: "preview-button-call-permission" },
                    [
                      _vm._v("\n                Choose preference "),
                      _c("a-icon", { attrs: { type: "down" } }),
                    ],
                    1
                  ),
                ])
              : _vm.currentStep > 0 &&
                _vm.form.templateType !== "CAROUSEL" &&
                _vm.form.buttons &&
                _vm.form.buttons.length
              ? _c(
                  "div",
                  { staticClass: "buttons-preview" },
                  _vm._l(_vm.form.buttons, function (button, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "preview-button" },
                      [
                        button.type === "URL"
                          ? _c("a-icon", { attrs: { type: "link" } })
                          : _vm._e(),
                        _vm._v(" "),
                        button.type === "PHONE_NUMBER"
                          ? _c("a-icon", { attrs: { type: "phone" } })
                          : _vm._e(),
                        _vm._v(" "),
                        button.type === "MPM"
                          ? _c("a-icon", { attrs: { type: "shopping-cart" } })
                          : _vm._e(),
                        _vm._v(" "),
                        button.type === "SPM"
                          ? _c("a-icon", { attrs: { type: "shopping" } })
                          : _vm._e(),
                        _vm._v(" "),
                        button.type === "COPY_CODE"
                          ? _c("a-icon", { attrs: { type: "copy" } })
                          : _vm._e(),
                        _vm._v(" "),
                        button.type === "OTP"
                          ? _c("a-icon", { attrs: { type: "mobile" } })
                          : _vm._e(),
                        _vm._v(
                          "\n                " +
                            _vm._s(button.text || "Button " + (index + 1)) +
                            "\n            "
                        ),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.form.templateType === "CAROUSEL"
              ? [
                  _vm.currentStep === 0
                    ? _c(
                        "div",
                        { staticClass: "carousel-whatsapp-message" },
                        _vm._l(3, function (n) {
                          return _c(
                            "div",
                            {
                              key: n,
                              staticClass: "carousel-whatsapp-message-item",
                            },
                            [
                              _c("div", { staticClass: "content-wrapper" }, [
                                _c("img", {
                                  attrs: {
                                    src: "https://static.supsis.live/common/image/fruits.png",
                                    alt: "Sample Card",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "body" }, [
                                  _vm._v(
                                    "Product " + _vm._s(n) + " description"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "buttons" }, [
                                _c(
                                  "div",
                                  { staticClass: "button url" },
                                  [
                                    _c("a-icon", { attrs: { type: "link" } }),
                                    _vm._v(
                                      " Shop now\n                        "
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm.form.carouselCards &&
                      _vm.form.carouselCards.length > 0
                    ? _c(
                        "div",
                        { staticClass: "carousel-whatsapp-message" },
                        _vm._l(_vm.form.carouselCards, function (card, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "carousel-whatsapp-message-item",
                            },
                            [
                              _c("div", { staticClass: "content-wrapper" }, [
                                card.media
                                  ? _c("div", { staticClass: "card-media" }, [
                                      card.headerFormat === "IMAGE"
                                        ? _c("img", {
                                            attrs: {
                                              src: card.media.data,
                                              alt: "Card Preview",
                                            },
                                          })
                                        : card.headerFormat === "VIDEO"
                                        ? _c("video", {
                                            attrs: {
                                              src: card.media.data,
                                              controls: "",
                                            },
                                          })
                                        : _vm._e(),
                                    ])
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "media-placeholder",
                                        class: card.headerFormat.toLowerCase(),
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "material-icons" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                card.headerFormat === "IMAGE"
                                                  ? "image"
                                                  : "play_circle_filled"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                card.body
                                  ? _c("div", { staticClass: "body" }, [
                                      _vm._v(_vm._s(card.body)),
                                    ])
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              card.buttons && card.buttons.length
                                ? _c(
                                    "div",
                                    { staticClass: "buttons" },
                                    _vm._l(
                                      card.buttons,
                                      function (btn, btnIdx) {
                                        return _c(
                                          "div",
                                          {
                                            key: btnIdx,
                                            staticClass: "button",
                                            class:
                                              btn.type === "QUICK_REPLY"
                                                ? "quick-reply"
                                                : "url",
                                          },
                                          [
                                            btn.type === "URL"
                                              ? _c("a-icon", {
                                                  attrs: { type: "link" },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            btn.type === "PHONE_NUMBER"
                                              ? _c("a-icon", {
                                                  attrs: { type: "phone" },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  btn.text ||
                                                    _vm.getButtonLabel(btn.type)
                                                ) +
                                                "\n                        "
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "preview-info" },
      [
        _c("h5", [_vm._v("This template is good for")]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.getPreviewDescription))]),
        _vm._v(" "),
        _vm.currentStep === 0
          ? [
              _c("h5", [_vm._v("Template areas that you can customise")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.getCustomisableAreas))]),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lto-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("card_giftcard")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "catalogue-card-preview" }, [
      _c("div", { staticClass: "catalogue-image-placeholder" }, [
        _c("span", { staticClass: "material-icons" }, [_vm._v("image")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "catalogue-info" }, [
        _c("div", { staticClass: "catalogue-title" }, [
          _vm._v("View {BIZ_NAME}'s Catalog on WhatsApp"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "catalogue-subtitle" }, [
          _vm._v("Browse pictures and details of their offerings."),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lto-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("card_giftcard")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "catalogue-card-preview" }, [
      _c("div", { staticClass: "catalogue-image-placeholder" }, [
        _c("span", { staticClass: "material-icons" }, [_vm._v("image")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "catalogue-info" }, [
        _c("div", { staticClass: "catalogue-title" }, [
          _vm._v("View {BIZ_NAME}'s Catalog on WhatsApp"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "catalogue-subtitle" }, [
          _vm._v("Browse pictures and details of their offerings."),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }